export const SYNTHETIC_TEST_IDS = {
  headerCta: 'sign-up-cta-header',
  bodyCta: 'sign-up-cta-body',
};
